import React, { useState } from 'react';
import { Play, Pause } from 'lucide-react';
import { Button } from '@easyflow/ui-frontend/components/ui/button';
import type { WorkspaceState } from '@easyflow/shared';

interface Props {
  state: WorkspaceState;
  onResume: (instruction?: string) => Promise<void>;
}

export const ResumeBar: React.FC<Props> = ({ state, onResume }) => {
  const [draft, setDraft] = useState('');
  const [busy, setBusy] = useState(false);

  if (state !== 'paused' && state !== 'awaiting_approval') return null;

  const submit = async () => {
    setBusy(true);
    try {
      await onResume(draft.trim() ? draft.trim() : undefined);
      setDraft('');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border-t border-amber-200 bg-amber-50 px-3 py-2">
      <div className="flex items-center gap-2 mb-1.5">
        <Pause className="h-3.5 w-3.5 text-amber-700" />
        <span className="text-xs font-medium text-amber-900">
          {state === 'awaiting_approval' ? 'In attesa di conferma' : 'Esecuzione in pausa'}
        </span>
      </div>
      <div className="flex items-end gap-2">
        <textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Istruzione opzionale per il prossimo round (es: ignora i risultati precedenti e riparti da…)"
          rows={1}
          className="flex-1 text-xs border border-amber-300 bg-card rounded px-2 py-1.5 resize-none focus:outline-none focus:ring-2 focus:ring-inset focus:ring-amber-500"
        />
        <Button
          size="sm"
          className="h-8 bg-amber-600 hover:bg-amber-700 text-white"
          onClick={submit}
          disabled={busy}
        >
          <Play className="h-3 w-3 mr-1" /> Riprendi
        </Button>
      </div>
    </div>
  );
};
